
import { Button } from "@/components/ui/button";

interface EmptyCollectionStateProps {
  onAddContent: () => void;
}

const EmptyCollectionState = ({ onAddContent }: EmptyCollectionStateProps) => {
  return (
    <div className="text-center py-10 bg-clustr-lightGray/50 rounded-lg">
      <p className="text-clustr-darkGray mb-4">No content items found</p>
      <Button 
        onClick={onAddContent}
        className="bg-clustr-blue hover:bg-blue-600 transition-colors"
      >
        Add Your First Content
      </Button>
    </div>
  );
};

export default EmptyCollectionState;
